import React, { useState, useEffect } from "react"
import TableHolder from "../components/TableHolder"
import { useTranslation } from "react-i18next"
import { apiGet } from "../utils/apiConnector"
import { emissionsApi } from "../config/apiUrls"
import { useDispatch, useSelector } from "react-redux"
import { Dimmer, Loader } from "semantic-ui-react"

const ReportsPage = () => {
  const { t } = useTranslation()
  const [reports, setReports] = useState([])
  const [innerData, setInnerData] = useState([])
  const [isLoading, setIsLoading] = useState(false)
  const { profile } = useSelector((state) => ({ profile: state.profile }))
  const getReports = () => {
    const ownerId = profile.id
    setIsLoading(true)
    apiGet(emissionsApi + "/" + ownerId + "/info")
      .onOk((res) => {
        console.log(res.data.response)
        setReports(res.data.response)
      })
      .onFail(() => {})
      .afterAll(() => {
        setIsLoading(false)
      })
      .startSingle()
  }
  const getInnerData = (id) => {
    reports.map((q) => {
      if (q.id === id) {
        setInnerData(q.items)
      }
    })
  }
  useEffect(() => {
    getReports()
    return () => {}
  }, [])
  const config = {
    fname: t("Reports"),
    data: reports,
    headers: [
      { name: "gtin", title: "GTIN" },
      // { name: "id", title: "ID" },
      // { name: "orderId", title: "Order ID" },
      { name: "productName", title: "Product name" },
      { name: "qty", title: "Quantity" },
      { name: "status", title: "Status" },
      { name: "dt", title: "Date" },
      { name: "available", title: "Available" },
    ],
    onClick: getInnerData,
    isLoading: () => isLoading,
    inner: {
      fname: t("Reports"),
      data: innerData,
      headers: [
        { name: "code", title: "Product code" },
        { name: "isAvailable", title: "Available" },
        { name: "isChecked", title: "Checked" },
        { name: "isGenerated", title: "Generated" },
        { name: "markID", title: "Mark ID" },
        { name: "status", title: "Status" },
      ],
    },
  }
  return (
    <>
      <div>
        <h2>{t("ReportsPage")}</h2>
        <TableHolder config={config} />
      </div>
    </>
  )
}

export default ReportsPage
